<template>
  <BasePaymentForm
    :showSecured="true"
  >
    <template #body>
      <div class="form-group mb-1">
        <BaseCreditCardForm
          :form.sync="form"
          :validate.sync="validate"
          :state="paymentMethod"
          :isSubmitted="isSubmitted"
          :inputClassName="`form-control-sm`"
        />
      </div>
      <div class="form-group mb-1">
        <SectionHeader :title="$t('apps.payment.message.item')"/>
        <Table :invoice="invoice" />
      </div>
    </template>
    <template #footer-text>
      {{ $t('apps.payment.message.amounttotal') }}:
      {{ getCurrencyWithNumber(numberel(invoice.total, '0,0.00')) }}
    </template>
    <template #footer-actions>
      <BaseButton
        :text="$t('button.prev')"
        :className="`btn-secondary mr-2`"
        :disabled="isSubmitted"
        @click="onClickPrev"
      />
      <BaseButton
        :className="`btn-web`"
        :disabled="isSubmitted || nextBtnDisabled"
        @click="onClickNext"
      >
        {{
          $t('apps.billing.button.payamount', {
            number: getCurrencyWithNumber(numberel(invoice.total, '0,0.00'))
          })
        }}
        <i
          v-if="isSubmitted"
          class="fas fa-spinner spin"/>
      </BaseButton>
    </template>
  </BasePaymentForm>
</template>

<script>
import Table from '@/components/payment/InvoiceListTable.vue'

export default {
  components: {
    Table,
  },

  props: {
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Object,
      default: () => ({}),
    },
    paymentMethod: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      form: null,
      validate: null,
    }
  },

  computed: {
    nextBtnDisabled () {
      return false
    },
  },

  methods: {
    onClickPrev () {
      this.$emit('prev')
    },
    onClickNext () {
      const isValid = this.validate()
      if (isValid) {
        this.$emit('next', this.form)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/payment/InvoiceConfirm.vue